import React, { useMemo, useState } from "react";
import styled, { css } from "styled-components";

import { hexToRGBA } from "../../../../utils/theme";
import { PRODUCTS } from "../../../../constants/V2-reflection-3/products";

import ContactUsForm from "../../forms/ContactUsForm";
import PaymentForm from "../../forms/PaymentForm";
// import LLCIncForm from "../../forms/LLCIncForm";
// import LLCIncFinalizeForm from "../../forms/LLCIncFinalizeForm";
// import LLCUpsellForm from "../../forms/LLCUpsellForm";
import OrderStatusForm from "../../forms/OrderStatusForm";
import EINSolePropForm from "../../forms/EINSolePropForm";
import EINPartnershipForm from "../../forms/EINPartnershipForm";
import EINCCorpForm from "../../forms/EINCCorpForm";
import EINSCorpForm from "../../forms/EINSCorpForm";
import EINEstateForm from "../../forms/EINEstateForm";
import EINNonProfitForm from "../../forms/EINNonProfitForm";
import EINLLCForm from "../../forms/EINLLCForm";
import EINTrustForm from "../../forms/EINTrustForm";
import EINPSCForm from "../../forms/EINPSCForm";
import EINChurchForm from "../../forms/EINChurchForm";
import { config } from "../../../../../../_config";

const { email } = config;
const StyledFormSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 2rem;

  width: 100%;

  .form-section-header {

    margin-top: 24px;
    margin-bottom: 8px;

    font-family: 'RobotoRegular';
    font-size: 20px;
    line-height: calc(1.42857rem * (20 / 16));
    text-align: center;
    color: #424242;

    span {
      font-family: 'RobotoBold';
    }
  }

  .form-section-container {
    display: flex;

    .form-container {
      flex-grow: 1;
      margin-right: 16px;

      .form-group {
        margin-bottom: 0;
      }
    }

    .hint-container {
      min-width: 300px;
      width: 300px;
      font-family: 'RobotoRegular';
      display: flex;
      align-items: flex-start;

      .hint-card {
        position: sticky;
        width: 100%;
        top: 0;
        border: 1px solid ${hexToRGBA('#000000', 0.1)};
        background-color: ${hexToRGBA('#000000', 0.03)};
        font-family: 'RobotoRegular';
        .hint-card-title {
          padding: 15px 15px 0;
          margin-bottom: 0.5rem;
          font-family: 'RobotoBold';
          font-size: 12px;
          line-height: calc(1.42857rem * (12 / 16));
          color: #244f74;
        }

        .hint-card-subtitle {
          padding: 0 15px;
          margin-bottom: 1rem;
          font-family: 'RobotoBold';
          font-size: 13px;
          line-height: calc(1.42857rem * (13 / 16));
          color: #424242;
        }

        .hint-card-content {
          padding: 0 15px;
          margin-bottom: 1rem;
          font-family: 'RobotoRegular';
          font-size: 13px;
          line-height: calc(1.42857rem * (13 / 16));
          color: #424242;

          a {
            display: none;
          }

          ul {
            list-style: disc;
            padding-left: 32px;

            li {
              font-family: 'RobotoRegular';
              font-size: 13px;
              line-height: calc(1.42857rem * (13 / 16));
            }
          }
        }
      }

      .customer-service-card {
        display: flex;
        flex-direction: column;
        font-family: 'RobotoRegular';
        width: 100%;

        padding-left: 16px;

        .customer-service-card-title {
          margin-bottom: 1rem;
          font-family: 'RobotoBold';
          font-size: 20px;
          line-height: calc(1.42857rem * (20 / 16));
          color: #244f74;
        }

        .customer-service-card-content {
          display: flex;
          flex-direction: column;

          &, a {
            font-family: 'RobotoRegular';
            font-size: 13px;
            line-height: calc(1.42857rem * (13 / 16));
            color: #424242;
          }

          .customer-service-card-item {
            display: flex;
            margin-bottom: 0.5rem;

            .customer-service-card-item-label {
              width: 20%;
              font-family: 'RobotoBold';
            }
          }
        }
      }
    }
  }

  ${({ showHelpCenter }) => !showHelpCenter && css`

    .form-section-container {

      .form-container {
        margin-right: 0;
      }
      
      .hint-container {
        display: none;
      }
    }
  `};

  @media ${({ theme }) => theme.devices.laptopS} {

    .form-section-container {

      .hint-container {
        display: none;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .form-section-header {
      width: 100%;
    }

    .form-section-container {
      width: 100%;

      .form-container {
        margin-right: 0;
      }
    }
  }
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1024px) {
    width: 990px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
  @media (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 1170px;
  }
  @media (min-width: 1600px) {
    padding-left: 115px;
    padding-right: 115px;
    width: 1440px;
  }
`;

const classes = new Map([
  ["/LLCIncFinalize", "llc-inc-finalize"],
]);

const showHelpCenterMap = new Map([
  ["/contactus", true],
  ["/payment", false],
  ["/LLCInc", false],
  ["/LLCIncFinalize", false],
  ["/LLCUpsell", false],
  ["/status", false],
  ["/products/EINSoleProp", false],
  ["/products/EINPartnership", false],
  ["/products/EINCCorp", false],
  ["/products/EINSCorp", false],
  ["/products/EINEstate", false],
  ["/products/EINNonProfit", false],
  ["/products/EINLLC", false],
  ["/products/EINLLC2", false],
  ["/products/EINTrust", false],
  ["/products/EINPSC", false],
  ["/products/EINChurch", false],
]);

const forms = new Map([
  ["/contactus", ContactUsForm],
  ["/payment", PaymentForm],
  // ["/LLCInc", LLCIncForm],
  // ["/LLCIncFinalize", LLCIncFinalizeForm],
  // ["/LLCUpsell", LLCUpsellForm],
  ["/status", OrderStatusForm],
  ["/products/EINSoleProp", EINSolePropForm],
  ["/products/EINPartnership", EINPartnershipForm],
  ["/products/EINCCorp", EINCCorpForm],
  ["/products/EINSCorp", EINSCorpForm],
  ["/products/EINEstate", EINEstateForm],
  ["/products/EINNonProfit", EINNonProfitForm],
  ["/products/EINLLC", EINLLCForm],
  ["/products/EINLLC2", EINLLCForm],
  ["/products/EINTrust", EINTrustForm],
  ["/products/EINPSC", EINPSCForm],
  ["/products/EINChurch", EINChurchForm],
]);

// eslint-disable-next-line react/display-name
const FormSection = React.forwardRef(({ path, ...restProps }, ref) => {
  const [hintSubtitle, setHintSubtitle] = useState(null);
  const [hintContent, setHintContent] = useState(null);

  const product = useMemo(() => PRODUCTS.find(product => product.path === path?.replace("/products/", "").replace("2","")), [path]);
  const handleMouseEnter = ({ label, hint }) => {
    setHintSubtitle(label);
    setHintContent(hint);
  };

  const handleMouseLeave = () => {
    setHintSubtitle(null);
    setHintContent(null);
  };

  const Form = useMemo(() => forms.get(path), [path]);
  const extraClass = useMemo(() => classes.get(path) || "", [path]);
  const showHelpCenter = useMemo(() => showHelpCenterMap.get(path), [path]);
  const isContactUs = path === "/contactus";

  if (!Form) {
    return null;
  }

  return (
    <StyledFormSection showHelpCenter={showHelpCenter}>
      {isContactUs && (
        <div className="form-section-header">
          If you have any problems or questions with your application, our trained business filing experts are ready to assist you.&nbsp;
          <span>Representatives are available Monday through Friday, 9 AM - 5 PM PST</span>
        </div>
      )}
      <div className={`form-section-container ${extraClass}`}>
        <div className="form-container">
          <Form
            ref={ref}
            {...restProps}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </div>
        <div className="hint-container">
          {!isContactUs && (
            <div className="hint-card">
              <div className="hint-card-title">
                <span>Application Help Center</span>
              </div>
              <div className="hint-card-subtitle">
                {hintContent ? hintSubtitle : product?.customerName}
              </div>
              <div className="hint-card-content">
                {hintContent || product?.detailedDescription}
              </div>
            </div>
          )}
          {isContactUs && (
            <div className="customer-service-card">
              <div className="customer-service-card-title">
                <span>Customer Service</span>
              </div>
              <div className="customer-service-card-content">
                <div className="customer-service-card-item">
                  <div className="customer-service-card-item-label">
                    <span>
                      Hours:
                    </span>
                  </div>
                  <div className="customer-service-card-item-value">
                    <span>M-F, 9 AM - 5 PM PST</span>
                  </div>
                </div>
                <div className="customer-service-card-item">
                  <div className="customer-service-card-item-label">
                    <span>
                      Email:
                    </span>
                  </div>
                  <div className="customer-service-card-item-value">
                    <a href={`mailto:${email}?subject=Mail from Contact Us EinDocs Site`}>
                      {email}
                    </a>
                  </div>
                </div>
                <div className="customer-service-card-item">
                  <div className="customer-service-card-item-label">
                    <span>
                      Phone:
                    </span>
                  </div>
                  <div className="customer-service-card-item-value">
                    <a href="tel:1-888-675-9395"> 1-888-675-9395</a>
                  </div>
                </div>
                <div className="customer-service-card-item">
                  <div className="customer-service-card-item-label">
                    <span>
                      Address:
                    </span>
                  </div>
                  <div className="customer-service-card-item-value">
                    Corporate Filings LLC<br/>
                    16192 Coastal Hwy<br/>
                    Lewes, DE 19958
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </StyledFormSection>
  );
});

export default FormSection;
